import { Sun } from "lucide-react";

const Marquee = ({ items }) => {
  const row = (hidden) => (
    <div aria-hidden={hidden} className="flex shrink-0 items-center">
      {items.map((item, i) => (
        <span
          key={i}
          className="flex items-center gap-6 pr-6 text-xs sm:text-sm font-semibold uppercase tracking-[0.22em] whitespace-nowrap"
        >
          {item}
          <Sun className="h-4 w-4 text-orange-400 shrink-0" />
        </span>
      ))}
    </div>
  );
  return (
    <div data-testid="marquee" className="relative overflow-hidden bg-slate-950 py-4 select-none">
      <div className="flex w-max animate-marquee text-amber-50">
        {row(false)}
        {row(true)}
      </div>
    </div>
  );
};

export default Marquee;
